// @ts-check

import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import ValidationComponent from 'infrastructure/js/components/controls/ValidationComponent/validationComponent.js'
import './textAreaField.scss';

// @ts-ignore
import cn from 'classnames';


/**
 * @typedef {import('mat/js/types/HookFormTypes').HookForm_TextArea_Props} HookForm_TextArea_Props
 * 
 */





/**
 * @param {HookForm_TextArea_Props} props
 */
export default function PL_TextAreaField_Hook(props) {

  let { form, name, rules, ...rest } = props;
  
  let myErrors = form.formState.errors[name];
  let touched = form.formState.touchedFields[name];
  
  // console.log('myErrors ===> ', myErrors);


  let getClassName = () => {
    return props.className ?? '';
  }

  let getErrorClass = () => {
    if (myErrors && touched) {
      return "invalid";
    }
    return '';
  }

  let onChange = (data) => {
    // props.input.onChange(data);
    // if (props.onChangeCallback) {
    //   props.onChangeCallback(data.target.value);
    // }
  }
  
  let validationPropsAdapter = {
    error: myErrors?.message,
    touched: touched,
  };
  

  return (
    <span className={cn("PL-textAreaField", getErrorClass(), getClassName())}>
      <FormControl
        as="textarea"
        {...form.register(name, rules)}
        {...rest}
        // onChange={onChange}
      />
      <ValidationComponent {...validationPropsAdapter} />
    </span>
  );

}


